import '../../scss/sest.scss'

try {
    const Form = require('./form')
    const View = require('./view')
    const ExtensionService = require('live/services/extension')

    const sest = {
        name: 'SEST',
        type: 'liverig-sest',
        origin: 'Plugin Petrobras',
        roles: ['output'],
        icon: '/content/plugin-petrobras/sest.png',
        ui: {
            form: Form,
            view: View
        }
    }

    ExtensionService.register(sest)
} catch (e) {
    console.error(e)
}
